<template>
  <div class="vx-row">
    <div class="vx-col w-1/2 md:w-1/4">
      mantap
    </div>
    <div class="vx-col w-1/2 md:w-1/4">
      mantap
    </div>
    <div class="vx-col w-1/2 md:w-1/4">
      mantap
    </div>
    <div class="vx-col w-1/2 md:w-1/4">
      mantap
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopInstancy',
  data() {
    return {
      loading: true,
      chartData: {},
      width: 400,
      height: 150
    }
  },
  mounted(){
    this.getData();
  },
  methods: {
    async getData(){
      console.log('hello world');
      // const res = await this.$httpMpp.get('/app/statistic/visitor-by-agencies-data', {params : {year: this.filterYear}});
      // let data = res.data.data;
      // let colors = data.dataset.map(function (){
      //   return 'rgb(54, 162, 235)';
      // });

      // this.chartData = {
      //   labels: data.labels,
      //   datasets: [{
      //     label: `Jumlah Kunjungan`,
      //     data: data.dataset,
      //     backgroundColor: colors,
      //     borderColor: colors,
      //     borderWidth: 1,
      //     barThickness: 30
      //   }]
      // }
      // this.loading = false;
    }
  }
}
</script>